
const getProductUrl = (paramid) => {
    var productDetails = photoOrg.config.product_details_share.products;
    if(window.innerWidth <= "640"){
        productDetails = photoOrg.config.mobile_product_details_share.products;
    }
    for(var i=0;i < productDetails.length; i++){
        var  product = productDetails[i];
        if(product.name.toString() === paramid){
            return product.url;
        }
    }

}

const productWindowRef = (url) => {    
    let ProductRef = null;
    try{
        if(photoOrg.windowProdReferenceShare && photoOrg.windowProdReferenceShare.closed){
             ProductRef = null;
        }
        else{
            ProductRef = photoOrg.windowProdReferenceShare;
        }
    }catch(e){
        console.log("error thrown:"+e, 'warn');
       
    }
    if(ProductRef == null){
        photoOrg.windowProdReferenceShare = window.open(url, '_blank');
    }
    else if(ProductRef.document.location.href === url) {
        ProductRef.focus();
    }else{
        ProductRef.document.location.href = url;
        ProductRef.focus();
    }
}

const orderPrints = () => {
    productWindowRef(photoOrg.config.prints_builder_url + "?" + photoOrg.config.prints_sku_4x6);    
 }

const navigateToProduct = (param) => {
    photoOrg.config.product_uri = getProductUrl(param);
    photoOrg.config.redirectURL = photoOrg.config.store_url + photoOrg.config.product_uri;
    productWindowRef(photoOrg.config.redirectURL);
}


export const decideProductPage= (e) => {
    const productId = e.currentTarget && e.currentTarget.getAttribute("id");
    
    if(!productId){
        productId = "icon-link-prints-share"
        console.log("productId is empty, setting default productId::", productId);
    }

    console.log("productId ::", productId);
    try{
        if(productId === "icon-link-prints-share"){
            orderPrints();
        }else{
            navigateToProduct(productId);
        }
    }catch(e){
        photoOrg.clientLogger.error({description: "SHARE:public_share_landing_page:orderPrints:Exception", errorCode: "LIBRARY:SHARE", err_desc: e, err_stack: e.stack});
    }
}